import { render, staticRenderFns } from "./TNC.vue?vue&type=template&id=f19559f0&scoped=true"
import script from "./TNC.vue?vue&type=script&lang=js"
export * from "./TNC.vue?vue&type=script&lang=js"
import style0 from "./TNC.vue?vue&type=style&index=0&id=f19559f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19559f0",
  null
  
)

export default component.exports